import { apiCall, ApiConfig } from '../../config/api'
import { TypeMovement } from '../../interfaces'
import { getTypeMovementsAction } from '../actions/typeMovementActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_TYPE_MOVEMENTS } from '../types/typeMovementActionTypes'

export function* getTypeMovementsAsync() {
  try {
    const { status, data }: AxiosResponse<TypeMovement[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypeMovementApi}`
    )
    if (status === 200) {
      yield put(getTypeMovementsAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypeMovementsAction([], serverError.message))
  }
}

export function* watchGetTypeMovementsAsync() {
  yield takeEvery(GET_TYPE_MOVEMENTS, getTypeMovementsAsync)
}
